require('./RAInput.scss');

//@ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
// @ components
const { AmountInput } = require('commonsComponents/amountInput');
import { FormattedText, getLanguage } from 'core/i18n';

// @ utilities
const { formatAmount } = require('utilities/RACurrencyHelper');

class RAInput extends React.Component {
    getRange() {
        const { max, min, showRange } = this.props;
        let rangeElement;

        if (showRange) {
            const minOk = formatAmount(min, null, 0);
            const maxOk = formatAmount(max, null, 0);

            rangeElement = (
                <div className="ra-input__range-indicator">
                    <span>
                        <FormattedText value="raInput-rangeMin" injectedStrings={[minOk]} />
                    </span>
                    <span> / </span>
                    <span>
                        <FormattedText value="raInput-rangeMax" injectedStrings={[maxOk]} />
                    </span>
                </div>
            );
        }

        return rangeElement;
    }

    render() {
        const {
            amount,
            customClassName,
            disabled,
            error,
            errorMsg,
            max,
            maxBackEndFractionLength,
            min,
            name,
            onChange,
            showBlurZero,
            showRange,
        } = this.props;
        const rangeElement = this.getRange();
        const raInputClass = showRange ? 'ra-input ra-input__range' : 'ra-input';
        const amountInputClassName = classNames(raInputClass, {
            [customClassName]: customClassName,
        });

        return (
            <div className={amountInputClassName}>
                <AmountInput
                    amount={amount}
                    callback={onChange}
                    disablePaste
                    disabled={disabled}
                    error={error}
                    errorMsg={errorMsg}
                    language={getLanguage()}
                    max={max}
                    maxBackEndFractionLength={maxBackEndFractionLength}
                    min={min}
                    name={name}
                    overrideUI
                    showBlurZero={showBlurZero}
                />
                {rangeElement}
            </div>
        );
    }
}

RAInput.propTypes = {
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    customClassName: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
    max: PropTypes.number,
    maxBackEndFractionLength: PropTypes.number,
    min: PropTypes.number,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    showBlurZero: PropTypes.bool,
    showRange: PropTypes.bool,
};

RAInput.defaultProps = {
    maxBackEndFractionLength: 0,
    showRange: false,
};

module.exports = RAInput;
